import api from '../../utils/appApi'
import Notify from "../../utils/notify";
import {CheckoutPayment} from "./checkoutPaymentHandler";
import {__loco} from "../../utils/localization";
import {ConfirmButton} from "./ConfirmButton";
import {isGustsInformationRequired} from "./checkoutUtils";
import {PlaceOrderRequest} from "./request/placeOrderRequest";
import {PlaceOrderWithoutGuestsRequest} from "./request/placeOrderWithoutGuestsRequest";
import {getCheckoutDesktopSelectors} from "./selectors/checkoutSelectors";
import { dispatchClearCartItems } from "../swiss_ui/cart/Cart";
import {paymentValidators, validatePersonalInformationPaymentAndTerms, validators} from "./CheckoutLiveValidation";
import { siteSettings, getUserCurrency } from '../../utils/siteSettings';


/**
 * Class handling order placing logic, invoking of the validation flow,
 *    functionality and events related directly to order placing and interaction with PaymentHandler,
 *        which is a class providing a simple integration with Stripe.
 */
export class CheckoutOrderHandler
{
  /**
   * Constructor
   */
  constructor() {

    /**
     * Initialize notifier instance
     * @type {Notify}
     */
    this.notifier = new Notify();

    /**
     * Initialize payment handler instance depending on enabled payment system
     * @type {CheckoutPayment}
     */

    /**
     * Initialize payment handler for enabled payment system
     */

    this.initializePaymentHandler();


    /**
     * Define selectors used by this component
     */
    this.selectors = getCheckoutDesktopSelectors();

    /**
     * Define steps wrapper, as it is a different node for desktop and mobile screens
     *
     * @type {*|jQuery.fn.init|jQuery|HTMLElement}
     */
    this.$stepsWrapper = $('#desktop-steps');

    /**
     * Adjust selectors for mobile
     * @todo: Remove mobile dependency.
     */
    // if($(window).width() < 760) {
    //   this.$stepsWrapper = $('#mobile-checkout-block');
    //
    //   this.selectors.payment = getCheckoutMobilePaymentSelectors();
    //
    //   /**
    //    * Override confirmBtn selector
    //    * @type {string}
    //    */
    //   this.selectors.confirmBtn = '#mobile-checkout-confirm-btn';
    //
    // }

    /**
     * Initialize $confirmButton instance
     *
     * @type {ConfirmButton}
     */
    this.$confirmButton = new ConfirmButton($(this.selectors.confirmBtn));
    this.isValidStripeDetails = false
    this.isEmptyStripeDetails = true
    const self = this
    $(document).on('input', Object.values(self.selectors.payment.payer).join(', '), function(event){
      self.validateField(event.currentTarget, validators)
      // self.validateGuestInfo(self.isValidStripeDetails);
    })

    $('#holder').on('input', function(event) {
      self.validateField(event.currentTarget, paymentValidators)
    })
  }


  validateField(fieldEl, validators) {
    const fieldName = fieldEl.name
    const value = this.getFormFieldValue(fieldName, fieldEl)
    const fieldValidator = validators[fieldName]
    if (fieldValidator) {
      const errorMessage = fieldValidator(value)
      const currentTarget = $(fieldEl)
      const fieldWrapperEl = currentTarget.closest('.checkout__item')
      const errorMessageEl = fieldWrapperEl.find('.form-field-error')
      if(errorMessage) {
        // errorMessageEl
        errorMessageEl.html(errorMessage);
        // errorMessageEl
        errorMessageEl.attr("style", "display:block")
        fieldWrapperEl.addClass('field-error')
        return false
      } else {
        errorMessageEl.html('');
        errorMessageEl.attr("style", "display:none")
        fieldWrapperEl.removeClass('field-error')
      }
    }
    return true

  }


  getFormFieldValue(name, fieldEl) {
    const value = fieldEl.value
    const checked = fieldEl.checked
    if(name === 'payer_phonenumber') {
      const code = $('.iti__selected-dial-code').text()
      return `${code}${value}`
    } else if (name === 'checkOutTermsCondition') {
      return checked
    }
    return value ? value.trim() : ''
  }

  /**
   * Initialize payment handler
   */
  initializePaymentHandler()
  {
    if (siteSettings().pspIsStripe){
    this.paymentHandler = new CheckoutPayment({
      callbacks: {
        stripeValidationError: error => this.stripeValidationError(error),
        stripeValidationSuccess: data => this.stripeValidationSuccess(data),
        stripeValidationEmpty: data => this.stripeValidationEmpty(data)
      }
    });

    this.paymentHandler.initialize();
  }
  document.getElementById('checkOutTermsCondition').addEventListener('change',(event) => {
    // this.validateGuestInfo(true)
    this.validateField(event.currentTarget, validators)
  })
  }

  /**
   * Attach DOM Listeners
   */
  listen() {
    const self = this;

    // console.log('the request is');
    // console.log(self.buildRequest());

    /**
     * Desktop submit
     * @todo: Remove mobile dependency.
     */
    $('#confirm-button, #mobile-checkout-confirm-btn').on('click', function(e){
      let isValid = self.validateFormFields()
      if(!isValid) {
        return;
      }

      document.querySelector('.checkoutPageLoader').classList.remove('hideFullScreenLoader');
      e.preventDefault();
      self.trigger = e;
      // validate cart data, then depending on result it will fire different actions
      // see how validator is initialized and which callbacks are provided
      self.validator.validateCartData({paymentAction: true});
    });
  }

  validateFormFields() {
    let isValid = true
    const isStripe = !!$('[data-is-stripe]').attr('data-is-stripe')

    const isPayerInfoValid = this.runvalidators(validators)

    if(!isPayerInfoValid) {
      isValid = false
    }

    if (isStripe) {
      const isPaymentInfoValid = this.runvalidators(paymentValidators)
      if(!isPaymentInfoValid) {
        isValid = false
      }

      if(this.isEmptyStripeDetails || !this.isValidStripeDetails) {
        isValid = false
        if (this.isEmptyStripeDetails) {
          this.stripeValidationEmpty()
        }
      }
    }

    return isValid
  }

  runvalidators(validators) {
    let isValid = true
    Object.keys(validators).forEach(fieldId => {
      const fieldEl = $(`#${fieldId}`)
      if(fieldEl && fieldEl.length) {
        const valid = this.validateField(fieldEl[0], validators)

        if(!valid) {
          isValid = false
        }
      }
    })

    return isValid
  }

  /**
   * Set cart object to work with
   *
   * @param {CartStorage} cart
   */
  setCart(cart) {
    this.cart = cart;
    return this;
  }


  /**
   * Set validator instance
   *
   *
   * @param {CheckoutItemsValidator} validator
   */
  setValidator(validator) {

    this.validator = validator;

    this.setCart(this.validator.cart);

    /**
     * Overwrite afterRequest hook
     *
     * @param response
     * @param actionParams
     */
    this.validator.afterRequest = (response, actionParams) => this.validatorAfterRequestHook(response, actionParams);

    /**
     * Prevent renderer from re-rendering guests form
     */
    this.validator.renderer.setShouldRenderGuestsForm(false);

    return this;
  }


  /**
   * Set placeOrder request builder
   * @param requestBuilder
   * @return {CheckoutOrderHandler}
   */
  setRequestBuilder(requestBuilder)
  {
    this.requestBuilder = requestBuilder;
    return this;
  }

  /**
   * Hook into validator's afterRequest hook, receive server response as param,
   *    parse the response, if response is successful and no items were updated, continue to placing an order.
   *
   * @param {Object} response - Response received from server
   * @param {Object} actionParams - Params passed to the validator.validateCartData method, used for easy config transport.
   */
  validatorAfterRequestHook(response, actionParams) {

    /**
     * Skip this action if trigger was not "Confirm and pay"
     */
    if(!actionParams.paymentAction) {
      return;
    }

    const tours = response.tours;
    const hotels = response.hotels;

    // console.log('tour items');
    // console.log(tours);
    // console.log('hotel items');
    // console.log(hotels);

    let allowContinue = true;

    if(typeof tours === "undefined" || (!tours.status && (tours.status_details && tours.status_details !== 'EMPTY_CART'))) {
      allowContinue = false;
    }

    // console.log(allowContinue);

    if (tours.items) {
      Object.keys(tours.items).forEach(tourID => {
        const tourData = tours.items[tourID];
        if (!tourData.status) {
          allowContinue = false;
        }
      })
    }



    if(typeof hotels === "undefined" || !hotels.status && (tours.status_details && tours.status_details !== 'EMPTY_CART')) {
      allowContinue = false;
    }

    if (hotels.items) {
      Object.keys(hotels.items).forEach(tourID => {
        const hotelItem = hotels.items[tourID];
        if (!hotelItem.status) {
          allowContinue = false;
        }
      })
    }



    /**
     * If validation conditions are met - allow placing the order.
     */
    if(allowContinue) {
      this.placeOrder(this.buildRequest());
    } else {
      this.handleCartInvalidData(response);
    }
  }

  /**
   * Handle cart invalid data
   */
  handleCartInvalidData() {
    this.notifier.error(__loco('It seems that your cart contains some invalid items, please update the items in your cart in order to place the order.'));
  }

  /**
   * Check if validator is set
   *
   * @returns {boolean}
   */
  hasValidator() {
    return !!this.validator;
  }

  /**
   * Set response items
   *
   * @param items
   * @returns {CheckoutGuestsInformationForm} this instance
   */
  setItems(items) {
    this.items = items;
    return this;
  }

  /**
   * Check if items are set
   *
   * @returns {boolean}
   */
  hasItems() {
    return !!this.items;
  }

  /**
   * Build order request, including booking details (guest information) and payment information
   *
   * @returns {void}
   */
  buildRequest() {

    if(isGustsInformationRequired()) {
      return new PlaceOrderRequest(this).buildRequest();
    } else {
      // console.log('should start here');
      return new PlaceOrderWithoutGuestsRequest(this).buildRequest();
    }

  }

  /**
   * Get payment request
   *
   * @returns {{details: {card_holder: (*|jQuery|string|undefined), country_code: (*|jQuery|string|undefined), expires: (*|jQuery|string|undefined), cvv: (*|jQuery|string|undefined), notes: (*|jQuery|string|undefined), cc_number: (*|jQuery|string|undefined)}, payer: {name: (*|jQuery|string|undefined), email: (*|jQuery|string|undefined)}}}
   */
  getPaymentRequest() {
    const totalCurrencyTypeElement = document.getElementById(this.selectors.payment.currency_type)
    return {
      currency_type:totalCurrencyTypeElement ? totalCurrencyTypeElement.innerHTML : getUserCurrency(),
      payer: {
        // name: $(this.selectors.payment.payer.name).val(),
        first_name: $(this.selectors.payment.payer.first_name).val(),
        last_name: $(this.selectors.payment.payer.last_name).val(),
        email: $(this.selectors.payment.payer.email).val(),
        phonenumber: $(this.selectors.payment.payer.phonenumber).val(),
        area_code: document.querySelector('.iti__selected-dial-code').innerHTML
      },
      details: {
        // cc_number:    $(this.selectors.payment.details.cc_number).val(),
        // expires:      $(this.selectors.payment.details.expires).val(),
        // cvv:          $(this.selectors.payment.details.cvv).val(),
        card_holder:  $(this.selectors.payment.details.card_holder).val(),
        country:      $(this.selectors.payment.details.country).val(),
        notes:        $(this.selectors.payment.details.notes).val()
      }
    };
  }

  beforePlaceOrder()
  {
    this.$confirmButton.buttonValidatingOrder();
  }

  /**
   * Perform placeOrder request
   *
   * @param request
   */
  placeOrder(request) {

    this.beforePlaceOrder();

    // console.log('placing order with request');
    // console.log(request);
    api.public.checkout
      .placeOrder(request)
      .then(response => this.handlePlaceOrderResponse(response.data))
      .catch(error => {this.handlePlaceOrderError(error.response.data)});
  }

  /**
   * Handle place order request
   *
   * After placeOrder was completed,
   *  stripe payment will be initiated.
   *
   * @see CheckoutPayment
   * @param response
   */
  handlePlaceOrderResponse(response) {

    /**
     * Cache the response from placeOrder action.
     */
    this.orderResponse = response;

    // console.log(response);

    /**
     * If OrderService was placed successfully and the response includes paymentIntent and paymentDetails
     *  - Initialize stripe payment.
     */
    console.log(response.data.paymentIntent === null);
    if(response.data.status
      && response.data.paymentIntent !== undefined
      && response.data.paymentDetails !== undefined && response.data.paymentIntent !== null) {
        
        // store the latest payment intent so we may cancel it in case of stripe-related errors.
        this.responseData = response.data;

      // set button state to - processing payment
      this.$confirmButton.buttonProcessingPayment();

      /**
       * Initialize Stripe payment
       */
      this.paymentHandler.initializePayment({
        cardHolderName: response.data.paymentDetails.card_holder,
        clientSecret: response.data.paymentIntent.client_secret,
        orderResponse: response,
        responseCallback: result => this.paymentResponseCallback(result)
      })

    } else if (response.data.paymentIntent === null){
      /**
             * @todo: This duplicates webhook ation so it may be needed to remove later.
             * @type {{payment_intent_id: *, client_secret: *, status: *}}
             */
       const request = {
        status: "succeeded",
        payment_token: response.data.payment_token,
      };
    // hold to 'processing payment' button state.
        // this.$confirmButton.buttonPaymentSuccess();
    this.updatePaymentStatus(request);
    }else {
      document.querySelector('.checkoutPageLoader').classList.add('hideFullScreenLoader');
      this.$confirmButton.resetButton();
      this.notifier.error(__loco('Something went wrong while processing your order. We did not charge this order, you can try again later.'));
    }
  }

  /**
   * Stripe payment response callback
   *
   * @see CheckoutPayment
   * @param result
   */
  paymentResponseCallback(result)
  {

    const self = this;

    /**
     * Handle payment error
     */
    if (result.error) {
      // Display error.message in your UI.
      this.notifier.error(result.error.message);

      /**
       * Handle payment status update
       * Will update payment status so it matches the status provided by stripe.
       */
      let responseData = self.responseData;

      // look at latest payment intent.
      if(result.error.payment_intent !== undefined) {
        paymentIntent = result.error.payment_intent;
      }

      /**
       * @type {{payment_intent_id: *, client_secret: *, status: *}}
       */
      const request = {
        payment_intent_id: responseData.paymentIntent.id,
        client_secret: responseData.paymentIntent.client_secret,
        status: responseData.paymentIntent.status,
        payment_intent: paymentIntent,
        payment_token:responseData.payment_token,
      };

      this.$confirmButton.buttonPaymentError();
      this.updatePaymentStatus(request);

      setTimeout(function(){
        self.$confirmButton.resetButton();
      }, 3000);

    } else {
/**
       * Handle payment status update
       * Will update payment status so it matches the status provided by stripe.
       */
 let responseData = self.responseData;
      /**
       * Handle payment successful
       * Will update payment status so it matches the status provided by stripe.
       */
      const paymentIntent = result.paymentIntent;

      /**
       * @todo: This duplicates webhook ation so it may be needed to remove later.
       * @type {{payment_intent_id: *, client_secret: *, status: *}}
       */
       const request = {
        payment_intent_id: paymentIntent.id,
        client_secret: paymentIntent.client_secret,
        status: paymentIntent.status,
        payment_intent: paymentIntent,
        payment_token:responseData.payment_token,
      };
      // hold to 'processing payment' button state.
      // this.$confirmButton.buttonPaymentSuccess();
      this.updatePaymentStatus(request);
    }
  }

  /**
   * @param request
   */
  updatePaymentStatus(request)
  {
    api.public.checkout.updatePaymentStatus(request).then((response) => {
      this.clearCartData();

      setTimeout(function(){
        if(response.data.data.status && response.data.redirect_url) {
          window.location = response.data.redirect_url;
        }
      }, 300);

    }).catch(() => {
      // silence for now
    })
  }

  /**
   * Clear cart data
   */
  clearCartData()
  {
    dispatchClearCartItems([]);
    // this.cart.set({});
  }


  /**
   * Stripe callback - validation error
   *
   * @param error
   */
  stripeValidationError(error) {
    // this.$confirmButton.disableConfirmButton();
    this.isValidStripeDetails = false
    this.isEmptyStripeDetails = false
    // this.validateGuestInfo(this.isValidStripeDetails);
  }

  /**
   * Stripe validation callback - input empty
   *
   * @param data
   */
  stripeValidationEmpty(data) {
    // this.$confirmButton.disableConfirmButton();
    this.isValidStripeDetails = false
    this.isEmptyStripeDetails = true
    setTimeout(() => {
      if(this.isEmptyStripeDetails) {
        $('#card-errors').html(__loco('Your card number is incomplete.'))
      }
    }, 0)

    // this.validateGuestInfo(this.isValidStripeDetails);
  }

  /**
   * Stripe validation success callback
   */
  stripeValidationSuccess() {
    this.isValidStripeDetails = true
    this.isEmptyStripeDetails = false
    // this.validateGuestInfo(this.isValidStripeDetails);
  }
  validateGuestInfo(isValidStripePaymentData) {
    const isValid = validatePersonalInformationPaymentAndTerms()
    if(isValid && (isValidStripePaymentData || !siteSettings().pspIsStripe)){
      this.$confirmButton.enableConfirmButton();
    }else {
      this.$confirmButton.disableConfirmButton();
    }
  }

  /**
   * Handle request failure
   *
   * @param error
   */
  handlePlaceOrderError(error) {


    // @todo: Add inputs validation
    if(!!error.errors) {
      if (Object.values(error.errors) && Object.values(error.errors).length) {
        Object.values(error.errors).forEach((message) => {
          this.notifier.error(message);
        });
      }
    } else {
      this.notifier.error("Please Try Again!");
    }

    this.$confirmButton.resetButton();
    document.querySelector('.checkoutPageLoader').classList.add('hideFullScreenLoader');
  }
}
